export const meta = {
  title: 'Contact CADCraft AI',
  description:
    'Contact the CADCraft AI community guide with questions, corrections, and suggestions.',
  updated_at: '2026-10-15',
};

## Email support

The main way to contact us is [support@cadcraft.org](mailto:support@cadcraft.org). You can use this address for questions about a guide, broken links, translation issues, accessibility, privacy, or topics you would like us to cover.

We usually reply within **two to three business days**. Questions that require checking a release, reproducing a command, or comparing file-format behavior may take longer. If you are following up on an existing message, please reply in the same thread so we can keep the context.

For a useful technical report, include the CADCraft version, operating system, input file type, exact command or steps, and the error message. A small reproducible drawing or a screenshot can help, but please remove private or confidential project information before sending it.

CADCraft AI is an independent guide, not the official CADCraft project or a support channel for Autodesk, Inc. or the ArtCraft team. We can correct our own pages and point you to official project resources, but we cannot guarantee an official software fix or answer on behalf of those organizations.
